export function _nextOrPrevAll(nextOrPreviousElementSibling, pushOrUnshift, selector, element) {
    const res = [];
    while(element = element[nextOrPreviousElementSibling]){
        if (element.matches(selector)) res[pushOrUnshift](element);
    }
    return res;
}
